import React, { useContext, useEffect } from 'react';
import './HorizontalTree.css';
import { useParams, Link } from "react-router-dom";

import { JourneyContext } from '../../../../Contexts/JourneyContext'
import { CurrentUserContext } from '../../../../Contexts/CurrentUserContext'
import api from '../../../../Utils/Api';


const HorizontalTree = ({ id, type }) => {
    const { currentPlace, breadCrumbs, setBreadCrumbs, setCurrentPlace } = useContext(JourneyContext)
    console.log(breadCrumbs)
    return (
        breadCrumbs && <div className='performance__navTree'>

            <Link to={'/'}> <div >Главная</div></Link>
            {
                breadCrumbs.map((i, index) => (
                    <Link key={index} to={`/${i.type}/${i.id}`}>  <div className={`${index + 1 === breadCrumbs.length ? 'current' : ''}`}>{i.title}</div></Link>

                ))
            }

        </div>

    )
}
export default HorizontalTree
